import React from "react";

const CurrencyContext = React.createContext("");

export default CurrencyContext;
